import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowExpression } from './dataflowexpression';
import { Owned } from '../base/named';
import { DataFlowTypesUtils } from './dataflow-type-utilities';

export enum ConditionExpressionType {
    EQUALS = '==',
    NOT_EQUALS = '!=',
    LESS_THAN = '<',
    LESS_THAN_EQUAL = '<=',
    GREATER_THAN = '>',
    GREATER_THAN_EQUAL = '>=',
    EQUALS_NULL = '===',
    EQUALS_CASE_INSENSITIVE = '<=>'
}

export const equalityConditionTypes = [ConditionExpressionType.EQUALS, ConditionExpressionType.EQUALS_CASE_INSENSITIVE, ConditionExpressionType.EQUALS_NULL];

@Metamodel.model({
    name: 'conditionExpression'
})
export class ConditionExpression extends Owned {
    public static readonly MODEL: IModel;

    public get isNonEqualityCondition(): boolean {
        return !equalityConditionTypes.includes(this.conditionType);
    }

    @Metamodel.attribute({
        display: stringResources.DataFlowLeftExpressionLabel,
        constraint: {
            required: true
        }
    })
    public leftExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    @Metamodel.attribute({
        display: stringResources.DataFlowRightExpressionLabel,
        constraint: {
            required: true
        }
    })
    public rightExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    @Metamodel.attribute({
        display: stringResources.DataFlowJoinSimilarityPercentageLabel,
        constraint: {
            required: false
        }
    })
    public overrideSimilarityThreshold = 80;

    @Metamodel.attribute({
    })
    public conditionType: ConditionExpressionType = ConditionExpressionType.EQUALS;

    public isTypesCompatible(): boolean {
        return this.leftExpression.returnType.typeString === 'any' && this.rightExpression.returnType.typeString === 'any' ? true :
            DataFlowTypesUtils.getWiderType(this.leftExpression.returnType, this.rightExpression.returnType).typeString !== 'any';
    }

    public hasComplexOrArrayType(): boolean {
        return this.leftExpression.returnType.typeString === 'complex' || this.rightExpression.returnType.typeString === 'complex'
            || this.leftExpression.returnType.typeString === 'array' || this.rightExpression.returnType.typeString === 'array' ;
    }

}
